import Vue from 'vue'
import { getCookie } from '../../../../ask/cookiejs'
import { post, fetch, Del, put } from '../../../../ask/axios'
import bus from '../../../../ask/eventBus'
import menberMenu from '../../../../components/userCenter/public/menberPageMenu.vue';
import { log } from 'util';
import { fileSteamDownload } from '@/utils/download'
export default {
  components: { menberMenu },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },

      titNames: 'My inquiry,Inquiry details',
      titUrls: '/myInquiry/airInquiry,',
      myHeaders: {
        ['X-JWT-TOKEN']: getCookie('JWT-TOKEN')
      },

      //-------------空运订单列表数据----------------//
      // InqDetails:{
      //   Order:'',
      //   AttachFiles:'',//附件
      // },
      InqDetails: {
        Order: {
          InquiryName: '', InWaybillNO: '', CreateTime: '', InquiryType: null, OrderServiceType: null, PlanDeliveryTime: '', Weight: '', VolumeCBM: '', PackageQuanlity: '',
          StartProNameCn: '', StartCityNameCn: '', StartCityAreaNameCn: '', StartCountryNameEn: '', DestProNameEn: '', DestCountryNameEn: '', DestCityNameEn: '', CusStatus: null,
          CloseReason: '',//询盘关闭的原因
        },
        CountDown: null,
        GoodsVolume: [],
        Attach: [],
      },


      //--------询价详情列表-------------//
      airInDetailsList: [],
      //airInListData:'',


      airInListData: {
        Price: {
          BJWaybillNO: '', PriceValidDate: '', PlanArrDate: '', TotalWorkDay: '', ThWorkDay: '', TotalMaxWorkDay: '', DepartureCode: '',
          DepartureName: '', DestinationCode: '', DestinationName: '', CusAirAmount: null, CusChargeWeight: null, ThAmount: null, ThChargeWeight: null, SpecialConditions: '', TotalAmount: null, TransferAirportInfo: '', DestAddressDesc: '',
        },
        AttachFiles: '',//附件
        Bill: [],
      },

      TransferAirportInfo: [],//中转机场数组

      isDataNone: false, //是否有渠道数据
      isLoading: false, //加载中...
      isData: false,
      airInDetailsListBox: [],//
    }
  },
  created() { //创建后
    this.detailsAPI(); //订单列表查询
    this.detailsListAPI();

  },
  mounted() { //载入dom后周期函数


  },
  watch: {//监听函数变化
    airInDetailsList: {
      handler(newVal) {
        console.log(newVal);
      },
      deep: true,
    }
  },
  computed: {//计算属性
    urlTitle() { //链接头部
      return this.$apiEn
    },
    //费用合计
    totolFee1() {
      let num = 0
      if (this.airInListData.Bill.length > 0) {
        this.airInListData.Bill.forEach(info => {
          if (info.BillType == 2) {
            num += Number(info.ForAmount)
          }
        })
      }
      return num + Number(this.airInListData.Price.CusAirAmount) + Number(this.airInListData.Price.ThAmount)
    },
    //费用合计
    totolFee2() {
      let num = 0
      if (this.airInListData.Bill.length > 0) {
        this.airInListData.Bill.forEach(info => {
          if (info.BillType == 3) {
            num += Number(info.ForAmount)
          }
        })
      }
      return num + Number(this.airInListData.Price.DeliverAmount)
    }
  },

  //方法
  methods: {
    fileDownload(url, name) {
      // window.location.href = this.$apiFileCloud + (url.indexOf('/') === 0 ? '' : '/') + url
      // window.location.hash = "target"
      //获取文件名后缀
      // let text = name.substring(name.lastIndexOf(".") + 1)
      // console.log(text);
      // if (text == "png" || text == "jpg") {
      //   window.open(this.$apiFileCloud + (url.indexOf('/') === 0 ? '' : '/') + url, '_blank')
      // } else {
      //   window.location.href = this.$apiFileCloud + (url.indexOf('/') === 0 ? '' : '/') + url
      // }
      fileSteamDownload(this, {
        FullPath: url, // 路径
        CurrentFileName: name // 文件名称
      }, name)
    },
    //把分钟转成小时，例如90分钟，1:30
    mToStr(m) {
      let h = Math.floor(m / 60);
      m -= h * 60;
      let hStr = h.toString().length;
      let mStr = m.toString().length;

      if (hStr > 1 && mStr > 1) {
        return (h ? h + ':' : '00:') + (m ? m : '00')
      } else if (hStr > 1 && mStr == 1) {
        return (h ? h + ':' : '00:') + (m ? '0' + m : '00')
      } else if (hStr == 1 && mStr == 1) {
        return (h ? '0' + h + ':' : '00:') + (m ? '0' + m : '00')
      } else if (hStr == 1 && mStr > 1) {
        return (h ? '0' + h + ':' : '00:') + (m ? m : '00')
      }
    },
    //-------------------------------第一部分查询信息---------------------------------//
    //询盘详情接口
    detailsAPI() {
      let that = this;
      this.api.param = {
        InWaybillNO: that.$route.query.billNO
      };
      this.api.url = this.$api04 + "/Air/api/AirInquiryOrder/AirInquiryDetail"
      post(this.api.url, this.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.InqDetails = res.Results
          setInterval(() => {
            that.InqDetails.CountDown--;
            if (that.InqDetails.CountDown <= 0) {
              that.InqDetails.CountDown = 0
            }
          }, 60000);
        }
      })
    },

    //-------------------------------第二部分列表信息---------------------------------//

    //报价列表接口
    detailsListAPI() {
      let that = this;
      this.api.param = {
        InWaybillNO: that.$route.query.billNO
      };
      that.isLoading = true; //加载中...
      that.isDataNone = false; //没有数据查无订单
      that.isData = false; //有数据列表
      //debugger
      this.api.url = this.$api04 + "/Air/api/AirInOrderSupPriceInfo/Query"
      post(this.api.url, this.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.isLoading = false;
          that.isData = true;
          if (res.Results) {
            if (res.Results.length < 0 || res.Results.length == 0) {
              that.isDataNone = true;
              that.isDataNone != that.isLoading;
            } else {
              that.isDataNone = false;
            }
          }

          that.airInDetailsList = res.Results
          let num = 0, num2 = 0;
          if (that.airInDetailsList.length > 0) {
            let listBox;
            that.airInDetailsList.forEach(e => {

              that.airDelAPI(e.BJWaybillNO);
              setTimeout(() => {
                if (that.airInDetailsListBox.length > 0) {
                  listBox = that.airInDetailsListBox.filter(item => {
                    return e.BJWaybillNO == item.Price.BJWaybillNO;
                  })
                }

                //console.log("集合----", listBox);
                //计算费用  费用类型。1：取件费用，2：空运费用，3：目的地费用，4：其他
                listBox[0].Bill.forEach(val => {

                  if (val.BillType == 2) {
                    num += Number(val.ForAmount)
                  }
                  e.Subtotal1 = num + Number(listBox[0].Price.CusAirAmount) + Number(listBox[0].Price.ThAmount)

                  if (that.InqDetails.Order.OrderServiceType == 1 || that.InqDetails.Order.OrderServiceType == 4) {
                    if (val.BillType == 3) {
                      num2 += Number(val.ForAmount)
                    }
                    e.Subtotal2 = num2 + Number(listBox[0].Price.DeliverAmount)
                  }



                })
                //e.airInDetailsList.Subtotal1 = num+Number(listBox.Price.CusAirAmount)+Number(listBox.Price.ThAmount)
                //console.log("=======hhhh", listBox);
                e.airInDetailsList = listBox;


              }, 300);
              //setTimeout(() => {
              Vue.set(e, 'isShowPage', 1)
              //}, 300);

            })
          }
          //console.log("集合----", that.airInDetailsList);
          //that.$forceUpdate();
        } else {
          that.isLoading = false;
          that.isDataNone = true;
        }
      })
    },

    //查看详情按钮点击事件
    clkBtnDeta(val, billNO) {
      this.airInDetailsList.forEach(e => {
        if (e.BJWaybillNO == billNO) {
          e.isShowPage = val
        }
      });
      if (val == 2) {
        //当前渠道
        //this.airDelAPI(billNO)
        this.$forceUpdate();
      }
    },
    //报价信息详情
    airDelAPI(billNO) {
      let that = this;
      this.api.param = {
        BJWaybillNO: billNO
      };
      this.api.url = this.$api04 + "/Air/api/AirInOrderSupPriceInfo/Detail"
      //const data = post(this.api.url, this.api.param);
      post(this.api.url, this.api.param).then(function (res) {
        if (res.IsOK) {
          //if (data.IsOK) {
          that.airInListData = res.Results
          that.airInDetailsListBox.push(res.Results);
          //TransferAirportInfo
          that.TransferAirportInfo = JSON.parse(res.Results.Price.TransferAirportInfo)
          // console.log('sdsd   ' + JSON.stringify(JSON.parse(that.airInListData.Price.TransferAirportInfo) ));

        }
      })
    },
    //费用列表单位转换
    JuderUnit(val) {
      if (val == 0) return 'Bill'
      if (val == 1) return 'CBM'
      if (val == 2) return 'Pcs'
      if (val == 3) return 'KG'
      if (val == 4) return 'page'
      if (val == 5) return 'B\\L'
      if (val == 6) return 'Day'
      if (val == 7) return 'Time'
      if (val == 8) return 'Unit'
    },
    //订单状态转换 
    transStatus(val) {
      // 客户状态。1：询价中，2：待确认，3：已下单，4：已过期
      if (val == 1) return 'In inquiry'
      if (val == 2) return 'To be confirmed'
      if (val == 3) return 'Booked'
      if (val == 4) return 'Expired'
    },

    //订单服务类型转换 
    transServType(val) {
      // 订单服务类型。1：门到门，2：门到机场，3：机场到机场，4：机场到门
      if (val == 1) return 'Door to Door'
      if (val == 2) return 'Door to Terminal'
      if (val == 3) return 'Terminal to Terminal'
      if (val == 4) return 'Terminal to Door'
      if (val == 5) return 'FOB'
      if (val == 6) return 'EXW'
      if (val == 7) return 'FCA'
    },
    //下单
    clkPlaceOrderbtn(item) {
      debugger

      let that = this;
      console.log("that.InqDetails.Order===", that.InqDetails.Order);
      //中转类型转换
      let airArrType = 0
      if (item.TransferAirport) {
        airArrType = 2
      } else {
        airArrType = 1
      }
      this.api.param = {
        Order: {
          AirChannelKey: item.ChannelKey,
          AirChannelName: item.ChannelName,
          AirCompanyKey: item.AirCompanyKey,
          AirCompanyCode: item.AirCompanyCode2,
          AirCompanyName: item.AirCompanyNameCn,
          AirCompanyCode3: item.AirCompanyCode3,
          DepartureCode: item.DepartureCode,
          DepartureName: item.DepartureName,
          DestinationCode: item.DestinationCode,
          DestinationName: item.DestinationName,
          FlightInfo: item.FligtCycle,
          ValidTerm: item.TotalWorkDay,
          AirArrivalType: airArrType,
          OrderPrice: item.CusAirAmount / item.CusChargeWeight,
          OrderAmount: item.TotalAmount,
          OrderTrafficAmount: item.CusAirAmount,
          Weight: that.InqDetails.Order.Weight,
          VolumeCBM: that.InqDetails.Order.VolumeCBM,
          PackageQuanlity: that.InqDetails.Order.PackageQuanlity,
          PackageUnit: that.InqDetails.Order.Unit,
          OrderWeight: that.airInListData.Price.CusChargeWeight,
          PlanDeliveryTime: new Date(that.InqDetails.Order.PlanDeliveryTime).Format('yyyy-MM-dd'),
          SecondFlight: '',
          TransferAirport: item.TransferAirport,
          OrderServiceType: that.InqDetails.Order.OrderServiceType,
          QueryGoodType: that.InqDetails.Order.QueryGoodType,
          CargoIDs: that.InqDetails.Order.CargoIDs,
          CargoNameCn: that.InqDetails.Order.CargoNameCn,
          CargoNameEn: that.InqDetails.Order.CargoNameEn,

          DepartureNameEn: item.DepartureNameEn,
          DestinationNameEn: item.DestinationNameEn,
          GoodsName: that.InqDetails.Order.GoodsName,
          Remarks: that.InqDetails.Order.Remark,
          RefNO: that.InqDetails.Order.InquiryName,
        },
        OrderExt: {
          StartCountryKey: that.InqDetails.Order.StartCountryKey,
          StartCountryNameCn: that.InqDetails.Order.StartCountryNameCn,
          StartCountryNameEn: that.InqDetails.Order.StartCountryNameEn,
          StartProKey: that.InqDetails.Order.StartProKey,
          StartProNameCn: that.InqDetails.Order.StartProNameCn,
          StartProNameEn: that.InqDetails.Order.StartProNameEn,
          StartCityKey: that.InqDetails.Order.StartCityKey,
          StartCityNameCn: that.InqDetails.Order.StartCityNameCn,
          StartCityNameEn: that.InqDetails.Order.StartCityNameEn,
          StartCityAreaKey: that.InqDetails.Order.StartCityAreaKey,
          StartCityAreaNameCn: that.InqDetails.Order.StartCityAreaNameCn,
          StartCityAreaNameEn: that.InqDetails.Order.StartCityAreaNameEn,
          DestCountryKey: that.InqDetails.Order.DestCountryKey,
          DestCountryNameCn: that.InqDetails.Order.DestCountryNameCn,
          DestCountryNameEn: that.InqDetails.Order.DestCountryNameEn,
          DestProKey: that.InqDetails.Order.DestProKey,
          DestProNameCn: that.InqDetails.Order.DestProNameCn,
          DestProNameEn: that.InqDetails.Order.DestProNameEn,
          DestCityKey: that.InqDetails.Order.DestCityKey,
          DestCityNameCn: that.InqDetails.Order.DestCityNameCn,
          DestCityNameEn: that.InqDetails.Order.DestCityNameEn,
          THChannelKey: item.ThChannelKey,
          DestSvcID: item.DestSvcID,
          IsStartCustoms: null,
          IsDestCustoms: that.InqDetails.Order.IsDestCustoms,
          IsBond: that.InqDetails.Order.IsBond,
          BondType: that.InqDetails.Order.BondType,
          BondValue: that.InqDetails.Order.BondValue,
          DestAddressDesc: that.InqDetails.Order.DestAddressDesc,
          OrderCostUnitPrice: that.airInListData.CostUnitPrice, //成本单价(目标币种)
          OrderCostCurrency: 2,//币种 英文网传美元
        },
        DeliverOrder: {
          DestSvcID: item.DestSvcID,
        },
        GoodVolumeList: that.InqDetails.GoodsVolume, //材积信息
        FeeItem: '',
        InWaybillNO: item.InWaybillNO,//询盘单号
        BJWaybillNO: item.BJWaybillNO,//报价单
        SupPriceID: item.ID,//报价表ID
        OrderAddType: 1, //订单下单类型。0：普通下单，1：大货询盘下单
      };
      //附件 this.api.param.AttachList 
      let AttachInfo = []
      if (that.InqDetails.Attach.length > 0) {
        that.InqDetails.Attach.forEach(k => {
          let infos = {
            OriginName: k.OriginName,
            BuildName: k.OriginName,
            Url: k.Url,
            OriginUrl: k.Url,
            UploadType: 0,
            AttachType: 6
          }
          AttachInfo.push(infos)
        })
      }
      this.api.param.AttachList = AttachInfo
      this.api.url = this.$api03 + "/api/TradeCustomer/AirOrderEn/AddConfirmOrder"
      post(this.api.url, this.api.param).then(function (res) {
        if (res.IsOK == true) {

          let startText = ''
          let endText = ''
          if (that.InqDetails.Order.OrderServiceType == 1 || that.InqDetails.Order.OrderServiceType == 2) {
            startText = that.InqDetails.Order.StartCityNameEn + ',' + that.InqDetails.Order.StartProNameEn + ',' + that.InqDetails.Order.StartCountryNameEn
          } else {
            startText = that.InqDetails.Order.DepartureCode + ',' + that.InqDetails.Order.DepartureNameEn
          }

          if (that.InqDetails.Order.OrderServiceType == 1 || that.InqDetails.Order.OrderServiceType == 4) {
            endText = that.InqDetails.Order.DestAddressDesc
          } else {
            endText = that.InqDetails.Order.DestinationCode + ',' + that.InqDetails.Order.DestinationNameEn
          }

          // that.submitOrder(res.Results.WaybillNO, item.TotalAmount, '', 'inquiry', startText, '', endText, '', that.InqDetails.Order.CargoNameEn,
          //  that.InqDetails.Order.Weight, that.InqDetails.Order.VolumeCBM, that.InqDetails.Order.PackageQuanlity, item.ChargeWeight, '',
          //  item.AirCompanyNameEn, that.airInListData.Price.CusAirAmount, '', '', '')

          window.location.href = "/air/airEdit?ord=" + res.Results.WaybillNO
        } else if (res.IsOK == false) {
          that.$confirm('failed!', "", {
            customClass: "custom-message-box", //自定义添加Class
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
            closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox 
            showCancelButton: false, //去掉取消按钮
            showClose: false, //去掉右上角的取消（X）
            //type: 'warning',
            center: true
          }).then(() => {
          }).catch(() => {
          });
          return false;
        }
      })
    },
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/userCenter/myInquiry/airInDetails.js